import { Search } from "lucide-react";

import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

export function IconSearch(props: IconWrapperProps) {
  return (
    <IconWrapper {...props}>
      <Search />
    </IconWrapper>
  );
}
